import { ValidationDialogState } from './State'

import {
  SET_IS_DIALOG_OPEN,
  SET_IS_INITIATIVE_ALERT_OPEN,
  SET_VALIDATION_OPTIONS,
  ValidationDialogActions
} from './Actions'

function validationButtonReducer(state: ValidationDialogState, action: ValidationDialogActions): ValidationDialogState {
  switch (action.type) {
    case SET_IS_DIALOG_OPEN:
      return Object.assign({}, state, { isDialogOpenState: action.payload })
    case SET_IS_INITIATIVE_ALERT_OPEN:
      return Object.assign({}, state, { isInitiativeAlertState: action.payload })
    case SET_VALIDATION_OPTIONS:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default validationButtonReducer
